import { gql } from '@apollo/client';

export const PROPERTY_OFFICE_FRAGMENT = gql`
  fragment PropertyOffice on Property {
    office {
      info {
        name
        hasSoldPrice
        urltag
      }
    }
  }
`;
